import React from 'react';
import { cn } from '../../lib/utils';
export type StatusType = 'hijau' | 'kuning' | 'merah' | 'neutral';
interface StatusBadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  status: StatusType;
  children: React.ReactNode;
}
export function StatusBadge({
  status,
  children,
  className,
  ...props
}: StatusBadgeProps) {
  const variants = {
    hijau: 'bg-green-100 text-green-800 border-green-200',
    kuning: 'bg-yellow-100 text-yellow-800 border-yellow-200',
    merah: 'bg-red-100 text-red-800 border-red-200',
    neutral: 'bg-gray-100 text-gray-800 border-gray-200'
  };
  return <span className={cn('inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border', variants[status], className)} {...props} data-id="element-446">
      {children}
    </span>;
}